import { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { BiSpreadsheet, BiTask } from 'react-icons/bi'
import { RiGuideLine } from 'react-icons/ri'
import { Menu } from 'antd'
import { MdMenuBook } from "react-icons/md";
import { FaBars } from 'react-icons/fa6'
import { IoClose } from 'react-icons/io5'
import { useLocation } from 'react-router-dom'
import { MdOutlinePublishedWithChanges } from "react-icons/md";
import { LuPrinterCheck } from "react-icons/lu";


export const Sidebar = ({ Emp_role, setsidebor }) => {
  const location = useLocation() // this updates on URL change

  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const [activeKey, setActiveKey] = useState('1')

  useEffect(() => {
    const path = location.pathname
  }, [location.pathname])
  const onOpenChange = (openKeys, key) => {
    setActiveKey('35')
  }

  useEffect(() => {
    setsidebor(isDrawerOpen)
  }, [isDrawerOpen])
  return (
    <aside
      className='max-w-[225px] bg-[#fff] text-white flex flex-col items-center py-10'
      style={{ borderRight: '1px solid #cfcfcf' }}
    >
      <div className='flex justify-between w-[100%] px-3 gap-4 items-center'>
        <button
          className='flex items-center justify-center rounded-[5px] h-[30px] w-[30px] bg-[#fff] border border-[#3b82f6]'
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
        >
          {isDrawerOpen ? (
            <IoClose className='text-[20px] text-[#3b82f6] ' />
          ) : (
            <FaBars className='text-[18px] text-[#3b82f6]' />
          )}
        </button>
        <img
          className={`side-logo1 relative w-[7rem] ${isDrawerOpen ? '' : 'hidden'
            }`}
          src='ink_logo-banner.png'
          alt='logo'
        />
        <img
          className={`side-logo2 w-[2rem] ${isDrawerOpen ? 'hidden' : ''}`}
          src='https://d2zsaxtqgik6nj.cloudfront.net/images/title_logo.png'
          alt='logo'
        />
      </div>
      {isDrawerOpen ? (
        <ul className='w-full mt-[1.5rem]'>
          <Menu
            mode='inline'
            theme='light'
            selectedKeys={[activeKey]}
            defaultSelectedKeys={['1']}
            onClick={({ key }) => setActiveKey(key)} // Update active key on click
          >
            {/* <Menu.Item
              key='1'
              icon={<BiSpreadsheet style={{ fontSize: '18px' }} />}
            >
              <NavLink to='/dashboard'>Dashboard</NavLink>
            </Menu.Item> */}

            <Menu.Item key='1' icon={<BiTask style={{ fontSize: '18px' }} />}>
              <NavLink to='/dashboard'>All</NavLink>
            </Menu.Item>

            <Menu.Item key='2' icon={<BiTask style={{ fontSize: '18px' }} />}>
              <NavLink to='/submitted'>submitted</NavLink>
            </Menu.Item>

            <Menu.Item key='3' icon={<RiGuideLine style={{ fontSize: '18px' }} />}>
              <NavLink to='/guided'>Guided</NavLink>
            </Menu.Item>

            <Menu.Item key='4' icon={<MdMenuBook style={{ fontSize: '18px' }} />}>
              <NavLink to='/do-it-yourself'>DIY</NavLink>
            </Menu.Item>
            <Menu.Item key='5' icon={<MdOutlinePublishedWithChanges style={{ fontSize: '18px' }} />}>
              <NavLink to='/published'>Published</NavLink>
            </Menu.Item>
            <Menu.Item key='6' icon={<LuPrinterCheck style={{ fontSize: '18px' }} />}>
              <NavLink to='/print-orders'>Print Orders</NavLink>
            </Menu.Item>
          </Menu>
        </ul>
      ) : (
        <ul className='w-full mt-[1.5rem]'>
          <Menu
            className='custom-menu'
            mode='inline'
            theme='light'
            defaultSelectedKeys={['1']}
            onOpenChange={onOpenChange}
          >
            <Menu.Item key='1'>
              <NavLink to='/dashboard'>
                <BiSpreadsheet style={{ fontSize: '18px' }} />
              </NavLink>
            </Menu.Item>

            <Menu.Item key='2'>
              <NavLink to='/submitted'>
                <BiTask style={{ fontSize: '18px' }} />
              </NavLink>
            </Menu.Item>
            <Menu.Item key='3'>
              <NavLink to='/guided'>
                <RiGuideLine style={{ fontSize: '18px' }} />
              </NavLink>
            </Menu.Item>
            <Menu.Item key='4'>
              <NavLink to='/do-it-yourself'>
                <MdMenuBook style={{ fontSize: '18px' }} />
              </NavLink>
            </Menu.Item>
            <Menu.Item key='5'>
              <NavLink to='/published'>
                <MdOutlinePublishedWithChanges style={{ fontSize: '18px' }} />
              </NavLink>
            </Menu.Item>
            <Menu.Item key='6'>
              <NavLink to='/print-orders'>
                <LuPrinterCheck style={{ fontSize: '18px' }} />
              </NavLink>
            </Menu.Item>
          </Menu>
        </ul>
      )}
    </aside>
  )
}
